
import {of as observableOf,  Observable } from 'rxjs';

import {catchError, map, retryWhen} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {api, handleError, retryStrategy, retryStrategyFor404} from '../../shared/api-loaders';
import {
  UserDetailOptions,
  RolesDisciplines,
  PdOfficeData,
  LpcRoles,
  Region,
  District,
  Facility
} from '../models/user-detail-options';
import { UserTypeNames } from '../models/user-type-names';
import { Select2Option } from '../../shared/select2-option';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from './user.service';
import { SecurityService } from '../../shared/security.service';
import {LpcRoleNames} from "../models/LpcRoleNames";

@Injectable()
export class UserDetailService {
  lpcRoleData: LpcRoles[];
  addDefaultOption(options: any[]): any {
    options.unshift({ id: ' ', text: 'Not Selected' });
    return options;
  }

  async getUserTypes(): Promise<any[]>  {

    let options = [
      { id: UserTypeNames.Corporate, text: UserTypeNames.Corporate },
      { id: UserTypeNames.CareSetting, text: UserTypeNames.CareSetting }
    ];
    let isLocalAdmin = await this.secSvc.isUserManagementLocalAdmin().toPromise();

    if (isLocalAdmin)
      return options.filter(x => x.id != UserTypeNames.Corporate);

    return options;
  }

  public getLpcRoles(configId: string): Observable<LpcRoles[]> {

    return this._http
      .get<LpcRoles[]>(api.lpcRoleData(configId)).pipe(
        retryWhen(retryStrategyFor404()), retryWhen(retryStrategy()));
  }

  constructor(private _http: HttpClient, private secSvc: SecurityService) { }

  public getOptions(): Observable<RolesDisciplines[]> {


    //return this._http
    //  .get("assets/userDetailOptions.json")
    //  .map(data => data.json())
    //  .catch(handleError);


    return this._http
      .get(api.userDetailOptions()).pipe(
      catchError(handleError),);
  }

  public getPdOffices(configId: string): Observable<PdOfficeData[]>{
    return this._http
      .get<PdOfficeData[]>(api.privateDutyOfficeData()).pipe(
        retryWhen(retryStrategy()));
  }

  public getUserPdOffice(configId: string, username: string, ssoId: string): Observable<PdOfficeData>{
    return this._http
      .get<PdOfficeData>(api.privateDutyUserOfficeData(configId, username, ssoId)).pipe(
        retryWhen(retryStrategyFor404()), retryWhen(retryStrategy()));
  }

  public isUserProvisionedForApp(ssoId : string, application : string) : Observable<boolean>{
    return this._http
      .get(api.userProvisionedForApp(ssoId, application)).pipe(
        catchError(handleError), );
  }

  public sortRegionsTree(regionsTree: Region[]) {
    regionsTree.sort((a, b) => a.name.localeCompare(b.name));
    regionsTree.forEach((region: Region) => {
      region.districts.sort((a, b) => a.name.localeCompare(b.name));
      region.districts.forEach((district: District) => {
        district.facilities.sort((a: Facility, b: Facility) => a.name.localeCompare(b.name));
      });
    });
  }
}
